function intercomCodeTemplate(APP_ID) {
  window.intercomSettings = {
    app_id: APP_ID,
    hide_default_launcher: true,
    vertical_padding: 60,
    horizontal_padding: 40,
  };

  (function () {
    const w = window;
    const ic = w.Intercom;

    if (typeof ic === 'function') {
      ic('reattach_activator');
      ic('update', w.intercomSettings);
      return;
    }

    if (w.__intercomScriptLoaded) {
      return;
    }

    w.__intercomScriptLoaded = true;

    const d = document;
    const i = function (...args) {
      i.c(args);
    };
    i.q = [];
    i.c = function (args) {
      i.q.push(args);
    };
    w.Intercom = i;
    const l = function () {
      const s = d.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = `https://travelata.ru/widget-intercom/widget/${APP_ID}`;
      const x = d.querySelectorAll('script')[0];
      x.parentNode.insertBefore(s, x);
    };
    l();
  })();
}

export default intercomCodeTemplate;
